import { render, staticRenderFns } from "./SliderPhoto.vue?vue&type=template&id=96bc811a&scoped=true"
import script from "./SliderPhoto.vue?vue&type=script&lang=js"
export * from "./SliderPhoto.vue?vue&type=script&lang=js"
import style0 from "./SliderPhoto.vue?vue&type=style&index=0&id=96bc811a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bc811a",
  null
  
)

export default component.exports